import waitUntil from './wait-until'
import { RouterState } from 'react-router'
import { Location } from 'history'

interface RouteProps {
  path?: string
  team?: string
}

function getRouteFromRouteTree(routes: RouteProps[]): string {
  return routes.map(route => route.path).join('/')
}

function getTeamFromRouteTree(routes: RouteProps[]): string {
  let team = 'unassigned'

  for (let i = routes.length; i--; ) {
    const route = routes[i]
    if (route.team) {
      team = route.team
      break
    }
  }

  return team
}

class RouteAttribution {
  /** The current route tree */
  currentRoute: string | null = null

  /** The team associated with the current route tree */
  currentTeam = 'unassigned'

  currentLocation: Location | null = null

  previousLocation: Location | null = null

  /** When the client-side route is initialized or the max time elapsed */
  initialized = waitUntil(() => this.currentRoute !== null)

  /**
   * On route change, capture the current route tree and Segment team attribution
   */
  setRoute(router: RouterState) {
    this.previousLocation = this.currentLocation
    this.currentLocation = router.location
    this.currentRoute = getRouteFromRouteTree(router.routes)
    this.currentTeam = getTeamFromRouteTree(router.routes)
  }

  /**
   * Gets the current route (waits until it has been set)
   * Use this function when you want to delay execution of some code
   * in a non-blocking way until we know the generic route matcher
   */
  async getCurrentRoute(): Promise<string | null> {
    await this.initialized
    return this.currentRoute
  }
}

export default new RouteAttribution()
